'use client';

import { useState, useEffect, useCallback } from 'react';

export const useLocationHash = (hash: string) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onHashChange = useCallback(() => {
    if (location.hash === `#${hash}`) {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  }, [hash]);

  useEffect(() => {
    if (!location) {
      return;
    }

    addEventListener('hashchange', onHashChange);
    return () => {
      removeEventListener('hashchange', onHashChange);
    };
  }, [onHashChange]);

  return isFocused;
};
